var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growht Indicator"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "rotate(180 29 29)",
    fill: "#04CE00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    d: "M26.5812 22.2118L26.5812 23.3123C26.5812 29.201 26.5812 35.0903 26.5812 40.9802C26.5812 42.1717 27.1546 43.0061 28.183 43.3838C29.1788 43.7426 30.1333 43.5314 30.7394 42.7279C31.1599 42.1301 31.3902 41.4192 31.4003 40.6883C31.4519 34.9421 31.4295 29.1959 31.4295 23.4496L31.4295 22.3611C31.6352 22.5067 31.8329 22.6632 32.0218 22.8298C33.179 23.9767 34.3207 25.1407 35.4864 26.2772C36.4084 27.1786 37.6651 27.1803 38.5492 26.3202C39.5124 25.381 39.5793 24.1724 38.6317 23.2127C35.9992 20.5459 33.353 17.8957 30.693 15.262C29.6166 14.1976 28.4354 14.1736 27.3572 15.2122C24.6812 17.7909 22.0247 20.3896 19.3877 23.0084C18.4211 23.9681 18.4812 25.1613 19.446 26.1107C20.3577 27.0052 21.532 27.0189 22.4951 26.1107C23.6351 25.0291 24.7493 23.92 25.8773 22.8247C26.0558 22.653 26.2498 22.5036 26.5812 22.2118Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/upIcon.733dfad0dc4231389ee5f61acb974c20.svg";
export { ForwardRef as ReactComponent };